import React, {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import axios from 'axios'
import Cookies from 'js-cookie'

import * as constants from 'constants/index.js'
import CardsHeader from 'layouts/Headers/CardsHeader.js'

import InputCustom from 'views/pages/components/InputCustom'
import {InputArraySelect,} from 'views/pages/components/InputSelect'
import TableCustom from 'views/pages/components/TableCustom'

import {Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Modal, Row,} from 'reactstrap'

import {hasPermission,} from 'views/policies/ResourceCategoryPolicy';

import {manageItems,} from 'views/policies/UserPolicy';
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import notify from '@utils/notify';

export default function ResourceCategories() {
  const permissions = useSelector(state => state.getState).permissions

  const [token, setToken] = useState('')
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState([])
  const [types, setTypes] = useState([])
  const [statuses, setStatuses] = useState([])

  const [editModal, setEditModal] = useState({
    show: false,
    header: '',
    division: ''
  })
  const [resourceCategory, setResourceCategory] = useState('')

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    header: '',
    body: '',
    onClick: null
  })

  const [errors, setErrors] = useState('')

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/resource-categories`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data
        setItems(data.data.items)
        setTypes(data.data.types)
        setStatuses(data.data.statuses)

        setTimeout(() => {
          setLoading(false)
        }, 500);
      } catch (error) {
        setLoading(false)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning('Warning', error.response ? error.response.statusText : 'Error occurred!')
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const addResourceCategory = async () => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${constants.API_URL}/resource-categories`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: resourceCategory
      })
      console.log('response :: ', response.data)
      const data = response.data
      setItems(data.data.items)
      
      setEditModal({
        ...editModal,
        show: false
      })
      setErrors('')
      notify.success(data.message)
    } catch (error) {
      setErrors('')
      console.error('error :: ', error)
      if (error.response && error.response.status === 422) {
        setErrors(error.response.data.errors)
        return
      }
      setEditModal({
        ...editModal,
        show: false
      })
      notify.warning(error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  const updateResourceCategory = async () => {
    try {
      const response = await axios({
        method: 'PUT',
        url: `${constants.API_URL}/resource-categories/${resourceCategory.slug}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: resourceCategory
      })
      console.log('response :: ', response.data)
      const data = response.data
      setItems(data.data.items)
      
      setEditModal({
        ...editModal,
        show: false
      })
      setErrors('')
      notify.success(data.message)
    } catch (error) {
      setErrors('')
      console.error('error :: ', error)
      if (error.response && error.response.status === 422) {
        setErrors(error.response.data.errors)
        return
      }
      setEditModal({
        ...editModal,
        show: false
      })
      notify.warning(error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  const deleteResourceCategory = async (resourceCategoryId) => {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${constants.API_URL}/resource-categories/${resourceCategoryId}`,
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
      console.log('response :: ', response.data)
      const data = response.data
      setItems(data.data.items)
      
      setDeleteModal({
        ...deleteModal,
        show: false
      })
      notify.success(data.message)
    } catch (error) {
      console.error('error :: ', error)
      setDeleteModal({
        ...deleteModal,
        show: false
      })
      notify.warning(error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  return (
    <>
      <CardsHeader name="Resources" parentName="Resource Category Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div className="d-flex justify-content-between">
                  <div>
                    <h1 className="title">Categories</h1>
                    <p className="text-sm mb-0">You can manage categories.</p>
                  </div>
                  {hasPermission(permissions, 'create-resource-categories') && 
                  <Button className="h-50" color="success" type="button" onClick={() => {
                    setResourceCategory('')
                    setEditModal({
                      ...editModal,
                      show: true,
                      header: 'Resource category information',
                      division: 'create'
                    })
                  }}>Add category</Button>}
                </div>
              </CardHeader>
              <CardBody>
                <TableCustom 
                  loading={loading}
                  items={items}
                  columns={[
                    {
                      dataField: "name",
                      text: "Name"
                    },
                    {
                      dataField: "is_active",
                      text: "Status",
                      formatter: (rowContent, row) => {
                        return statuses[row.is_active ? 1 : 0]
                      }
                    },
                    {
                      dataField: "type",
                      text: "Type",
                      formatter: (rowContent, row) => {
                        return row.resource_type? row.resource_type.name: ''
                      }
                    },
                    {
                      dataField: "",
                      text: "Active",
                      style: {
                        textAlign: 'right',
                        display: manageItems(permissions) ? 'block' : 'none'
                      },
                      headerStyle: {
                        display: manageItems(permissions) ? 'block' : 'none'
                      },
                      formatter: (rowContent, row) => {
                        return (
                          <>
                                <>
                                  <IcoMoon
                                      className={'cursor-pointer'}
                                      iconSet={IconSet}
                                      icon={'edit'}
                                      size={24}
                                      onClick={() => {
                                        setResourceCategory(row)
                                        setEditModal({
                                          show: true,
                                          header: 'Resource type information',
                                          division: 'update'
                                        })
                                      }}
                                  />
                                  <IcoMoon
                                      className={'cursor-pointer'}
                                      iconSet={IconSet}
                                      icon={'delete_outline'}
                                      size={24}
                                      onClick={() => setDeleteModal({
                                        show: true,
                                        header: 'Delete resource type',
                                        body: 'Are you sure you want to delete this resource type?',
                                        onClick: () => deleteResourceCategory(row.slug)
                                      })}
                                  />
                                </>
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={editModal.show}
          toggle={() => setEditModal({
            ...editModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title main-color">{editModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setEditModal({
                ...editModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <InputArraySelect 
              newLabel={`Resource Type`}
              options={types}
              value={resourceCategory && resourceCategory.resource_type_id ? resourceCategory.resource_type_id : ''}
              onChange={e => setResourceCategory({
                ...resourceCategory,
                resource_type_id: e.target.value
              })}
              valueKey={`id`}
              labelKey={`name`}
              defaultOption={true}
              invalid={errors && errors.resource_type_id ? true : false}
              errorMessage={errors.resource_type_id}
            />
            <InputCustom
                newLabel={`Name`}
              placeholder={`Name`}
              value={resourceCategory && resourceCategory.name ? resourceCategory.name : ''}
              onChange={e => setResourceCategory({
                ...resourceCategory,
                name: e.target.value
              })}
              invalid={errors && errors.name ? true : false}
              errorMessage={errors.name}
            />
            <InputCustom
              type={`number`}
              newLabel={`Order in menu list`}
              value={resourceCategory && resourceCategory.sort ? resourceCategory.sort : ''}
              onChange={e => setResourceCategory({
                ...resourceCategory,
                sort: e.target.value
              })}
              invalid={errors && errors.sort ? true : false}
              errorMessage={errors.sort}
            />
            <FormGroup>
              <label className="form-control-label">{`Status`}</label>
              {statuses && statuses.length > 0 &&
                statuses.map((status, index) => {
                  return (
                    <div className="custom-control custom-radio" key={index}>
                      <input
                        className="custom-control-input"
                        id={`customRadio${index}`}
                        name="customRadio"
                        type="radio"
                        checked={resourceCategory && index === resourceCategory.is_active? true: false}
                        onChange={() => setResourceCategory({
                          ...resourceCategory,
                          is_active: index
                        })}
                      />
                      <label className="custom-control-label" htmlFor={`customRadio${index}`}>
                        {status}
                      </label>
                    </div>
                  )
                })
              }
              <div className="invalid-feedback" style={{display: errors && errors.is_active? 'block': 'none'}}>
                {errors.is_active}
              </div>
            </FormGroup>
          </div>
          <div className="modal-footer justify-content-end">
            <ButtonContainer
                onClick={() => setEditModal({
                  ...editModal,
                  show: false
                })}
            >
              {`Close`}
            </ButtonContainer>
            <ButtonContainer
              reverse
              onClick={() => editModal.division === 'update' ? updateResourceCategory() : addResourceCategory()}
            >
              {`Save`}
            </ButtonContainer>
          </div>
        </Modal>
        <Modal
          isOpen={deleteModal.show}
          toggle={() => setDeleteModal({
            ...deleteModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title main-color">{deleteModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            {deleteModal.body}
          </div>
          <div className="modal-footer justify-content-end">
            <ButtonContainer
                onClick={() => setDeleteModal({
                  ...deleteModal,
                  show: false
                })}
            >
              {`Close`}
            </ButtonContainer>
            <ButtonContainer
              reverse
              onClick={deleteModal.onClick}
            >
              {`Delete`}
            </ButtonContainer>

          </div>
        </Modal>
      </Container>
    </>
  )
}